import React, { useEffect, useState } from 'react';

const Aboutde = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) return <p>Laden...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="container my-5">
      <h1 className="mb-4">Über uns</h1>

      <p>
        <strong>Vegbox GmbH</strong> ist ein modernes Gastronomieunternehmen mit Sitz in Dübendorf. 
        Unser Ziel ist es, kulinarische Erlebnisse auf höchstem Niveau zu bieten und gleichzeitig einen Ort 
        der Begegnung und Gastfreundschaft zu schaffen.
      </p>

      <h2 className="mt-5">Unsere Philosophie</h2>
      <p>
        Wir glauben an Qualität, Nachhaltigkeit und Authentizität. Unsere Speisen werden mit frischen, 
        saisonalen Zutaten zubereitet, die wir möglichst aus der Region beziehen. Dabei legen wir großen Wert 
        auf Handwerk, Kreativität und Liebe zum Detail.
      </p>

      <h2 className="mt-5">Unser Team</h2>
      <p>
        Hinter jedem Gericht steht ein leidenschaftliches Team aus Köchen, Gastgebern und Servicekräften. 
        Gemeinsam arbeiten wir daran, unseren Gästen ein unvergessliches Erlebnis zu bieten – ob bei einem 
        schnellen Lunch, einem gemütlichen Abendessen oder einer privaten Veranstaltung.
      </p>

      <h2 className="mt-5">Kontakt</h2>
      <p>
        Haben Sie Fragen oder möchten Sie mehr über uns erfahren?<br />
        Rufen Sie uns an unter <strong>+41782224236</strong> oder schreiben Sie uns an <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>.
      </p>

      <p className="mt-4"><em>Dübendorf, Januar 2025</em></p>
    </div>
  );
};

export default Aboutde;
